import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookiesConsent from './components/CookiesConsent';
import RequireVerifiedEmail from './components/RequireVerifiedEmail';
import FindBooking from './pages/FindBooking';
import Home from './pages/Home';
import About from './pages/About';
import Packages from './pages/Packages';
import TheLeague from './pages/TheLeague';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Booking from './pages/Booking';
import RequestDate from './pages/RequestDate';
import CustomerInfo from './pages/CustomerInfo';
import Payment from './pages/Payment';
import BookingSuccess from './pages/BookingSuccess';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import NotFound from './pages/NotFound';
import Guides from './pages/Guides';
import GuideCheckout from './pages/GuideCheckout';
import PurchaseAgreement from './pages/PurchaseAgreement';
import Catalog, { CATALOG_PATH } from './pages/Catalog';
import { LeagueProvider } from './context/LeagueContext';
import { LEAGUE_COMING_SOON } from './constants/league';
import { initAnalytics } from './analytics';
import {
  GUIDES_PATH,
  GUIDES_CHECKOUT_PATH,
  PURCHASE_AGREEMENT_PATH,
} from './constants/guides';

const consent = typeof window !== 'undefined' ? localStorage.getItem('cookieConsent') : null;
if (consent === 'accepted') {
  initAnalytics();
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const app = (
    <Router>
      <ScrollToTop />
      <div className="App dd-site">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/packages" element={<Packages />} />
            <Route path={CATALOG_PATH} element={<Catalog />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path={GUIDES_PATH} element={<Guides />} />
            <Route path={GUIDES_CHECKOUT_PATH} element={<GuideCheckout />} />
            <Route path="/league" element={<RequireVerifiedEmail><TheLeague /></RequireVerifiedEmail>} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path={PURCHASE_AGREEMENT_PATH} element={<PurchaseAgreement />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/request-date" element={<RequestDate />} />
            <Route path="/availability" element={<RequestDate />} />
            <Route path="/customer-info" element={<CustomerInfo />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/booking-success" element={<BookingSuccess />} />
            <Route path="/find-booking" element={<FindBooking />} />
            <Route path="/account/bookings" element={<Navigate to="/find-booking" replace />} />
            <Route path="/account/profile" element={<Navigate to="/find-booking" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <CookiesConsent />
      </div>
    </Router>
  );

  return LEAGUE_COMING_SOON ? app : <LeagueProvider>{app}</LeagueProvider>;
}

export default App;
